<template>
  <ion-page>
    <ion-tabs>
      <ion-tab-bar slot="bottom">
        <ion-tab-button tab="tab1" href="/home/tabs/tab1">
          <ion-icon icon="triangle" />
          <ion-label>Tab 1</ion-label>
        </ion-tab-button>

        <ion-tab-button tab="tab2" href="/home/tabs/tab2">
          <ion-icon icon="ellipse" />
          <ion-label>Tab 2</ion-label>
        </ion-tab-button>

        <ion-tab-button tab="tab3" href="/home/tabs/tab3">
          <ion-icon icon="square" />
          <ion-label>Tab 3</ion-label>
        </ion-tab-button>
      </ion-tab-bar>
    </ion-tabs>
  </ion-page>
</template>

<script>
export default {
  name: 'Tabs',
  mounted() {
    console.log('tabs mounted')
  },
  methods: {
    goTab(tab) {
      switch (tab) {
        case 'tab1':
          this.$router.push({ name: 'tab1' })
          console.log('saddssa')
          break

        default:
          break
      }
    }
  }
}
</script>
